import * as React from 'react';
import { makeSimpleRoute } from "@ova-studio/react-hyper-admin";
const Dashboard = React.lazy(() => import('./pages/Dashboard'));
const AnalyticsModule = {
    routes: [
        makeSimpleRoute({
            index: true,
            name: 'Початкова сторінка',
            element: React.createElement(Dashboard, null)
        })
    ]
};
export default AnalyticsModule;
//# sourceMappingURL=config.js.map